import { FC } from 'react';

import { ISatoshiResponse } from '~/modules/satoshi/interfaces/ISatoshiResponse';

import { SatoshiResultContainer } from './styles';
import { MessageRenderer } from '../../MessageRenderer';

interface IResultStepProps {
  visible: boolean;
  result: ISatoshiResponse;
  onFinish: () => void;
  onType: () => void;
}
export const ResultStep: FC<IResultStepProps> = ({
  visible,
  result,
  onFinish,
  onType,
}) => {
  return (
    <SatoshiResultContainer visible={visible}>
      {result && (
        <MessageRenderer
          content={result.message}
          onFinish={onFinish}
          onType={onType}
        />
      )}
    </SatoshiResultContainer>
  );
};
